<template>
  <BaseModal
    name="clientsModal"
    :clickToClose="false"
    :shiftY="0.5"
    :adaptive="true"
    :minHeight="725"
    height="725"
    :width="1280"
    classes="bg-transparent shadow-none"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div class="tw-mx-auto tw-w-[1280px] tw-h-[725px]">
      <BaseLoader v-if="modalInfo.loading"></BaseLoader>
      <div class="tw-bg-bgPage tw-h-full">
        <div
          v-if="dataForModal"
          class="tw-bg-white tw-p-[12px_26px] tw-text-forTitle tw-text-[12px] tw-flex tw-justify-between"
        >
          <div class="tw-flex tw-justify-between tw-w-full">
            <div class="tw-flex tw-gap-[10px]">
              <div class="tw-flex tw-gap-[5px]">
                {{ dataForHeader?.clientName }}
                ({{ dataForHeader?.clientId }} от
                {{
                  $time(dataForHeader.clientCreatedAt)
                    .utc(true)
                    .utcOffset(Number(this.userSetting.company__utc))
                    .format(`${this.userSetting.company__tempalte_date}`)
                }})
              </div>

              <div class="tw-flex tw-gap-[5px]">
                <div class="tw-text-forText">
                  {{ dataLang["clients_register_text_1"] }}
                </div>
                {{ dataForHeader.verifications?.yandexrent?.daysToEnd }}
              </div>

              <div class="tw-flex tw-gap-[5px]">
                <div class="tw-text-forText">
                  {{ dataLang["clients_register_text_2"] }}
                </div>
                {{ dataForHeader.verifications?.company?.daysToEnd }}
              </div>
              
              <div class="tw-flex tw-gap-[5px]">
                <div class="tw-text-forText">
                  {{ dataLang["clients_register_text_12"] }}
                </div>
                {{ dataForHeader.clientReting || 0 }}
              </div>
            </div>
            <div class="tw-flex tw-items-center tw-gap-[5px]">
              <div class="tw-text-forText">
                {{ dataLang["clients_register_text_7"] }}
              </div>
              <div
                v-html="
                  !dataForHeader.clientIsArchived
                    ? dataLang['clients_register_text_8']
                    : dataLang['clients_register_text_9']
                "
              ></div>
              &nbsp;
            </div>
          </div>
          <button
            type="button"
            class="btn-close"
            @click="$modal.hide('clientsModal')"
          ></button>
        </div>

        <hr class="tw-border-[1px] tw-border-[#899AB4] tw-mb-[10px] tw-mt-0" />

        <div>
          <VueTabs
            v-model="activateTab"
            @tab-change="handleTabChange"
            class="vue-tabs-type-1"
          >
            <!-- главная -->
            <VTab
              :title="dataLang['clients_register_text_10']"
              data-name="mainTab"
            >
              <div
                class="tw-my-[10px] tw-px-[26px]"
                style="max-height: 560px; min-height: 560px"
              >
                <MainTab
                  ref="mainTab"
                  v-if="listTabs.mainTab"
                  :modalInfo="modalInfo"
                ></MainTab>
              </div>
            </VTab>
            <!-- главная -->

            <!-- баланс -->
            <VTab
              :title="dataLang['clients_register_text_11']"
              data-name="balanceTab"
            >
              <div
                class="tw-my-[10px] tw-px-[26px]"
                style="max-height: 560px; min-height: 560px"
              >
                <BalanceTab
                  ref="balanceTab"
                  v-if="listTabs.balanceTab"
                  :modalInfo="modalInfo"
                ></BalanceTab>
              </div>
            </VTab>
            <!-- баланс -->

            <!-- рейтинг -->
            <VTab
              :title="dataLang['clients_register_text_12']"
              data-name="ratingTab"
            >
              <div
                class="tw-my-[10px] tw-px-[26px]"
                style="max-height: 560px; min-height: 560px"
              >
                <RatingTab
                  ref="ratingTab"
                  v-if="listTabs.ratingTab"
                  :modalInfo="modalInfo"
                ></RatingTab>
              </div>
            </VTab>
            <!-- рейтинг -->

            <!-- о клиенте -->
            <VTab
              :title="dataLang['clients_register_text_13']"
              data-name="aboutClientTab"
              ><div
                class="tw-my-[10px] tw-px-[26px]"
                style="max-height: 560px; min-height: 560px"
              >
                <AboutClientTab
                  ref="aboutClientTab"
                  v-if="listTabs.aboutClientTab"
                  :modalInfo="modalInfo"
                ></AboutClientTab></div
            ></VTab>
            <!-- о клиенте -->

            <!-- глобальный черный список -->
            <VTab
              :title="dataLang['clients_register_text_14']"
              data-name="blackListTab"
            >
              <div
                class="tw-my-[10px] tw-px-[26px]"
                style="max-height: 560px; min-height: 560px"
              >
                <BlackListClientsTab
                  ref="blackListTab"
                  v-if="listTabs.blackListTab"
                  :modalInfo="modalInfo"
                ></BlackListClientsTab>
              </div>
            </VTab>
            <!-- глобальный черный список -->
          </VueTabs>
          <div class="tw-flex tw-justify-between tw-px-[26px] tw-pb-[10px]">
            <div
              class="tw-bg-danger tw-text-[11px] tw-p-[10px_26px] tw-text-white tw-w-[70%]"
              v-if="BLAlert"
              v-html="BLAlert"
            ></div>
            <div v-if="!BLAlert"></div>
            <div class="tw-app-modal__footer !tw-m-0">
              <button
                @click="$modal.hide('clientsModal')"
                class="tw-app-btn-muted tw-app-btn-muted-lg"
              >
                {{ dataLang["orders_model_edit__btn_text5"] }}
              </button>
              <button
                @click="sendData"
                class="tw-app-btn-primary tw-app-btn-primary-lg"
              >
                {{ dataLang["orders_model_edit__btn_text6"] }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import GeneralService from "@/api/GeneralService";
import MainTab from "./MainTab.vue";
import SelectsService from "@/api/SelectsService.js";
import EventBus from "@/event-bus.js";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import BalanceTab from "./BalanceTab.vue";
import RatingTab from "./RatingTab.vue";
import AboutClientTab from "./AboutClientTab.vue";
import BlackListClientsTab from "./BlackListClientsTab.vue";
export default {
  components: {
    VueTabs,
    VTab,
    MainTab,
    BalanceTab,
    RatingTab,
    AboutClientTab,
    BlackListClientsTab,
  },
  data() {
    return {
      updatedValues: {},
      dataForModal: {},
      dataForHeader: {},
      newTab: null,
      oldTab: null,
      mainInfo: {},
      modalInfo: {
        modalOpened: false,
        id: null,
        loading: true,
      },
      listTabs: {
        mainTab: false,
        balanceTab: false,
        ratingTab: false,
        aboutClientTab: false,
        blackListTab: false,
      },
      activeCurrentTab: "mainTab",
      activateTab: null,
    };
  },
  methods: {
    sendData() {
      this.$refs[this.activeCurrentTab].sendData(
        this.assignedTabChange,
        "",
        "",
        "",
        true
      );
    },
    handleTabChange(tabIndex, newTab, oldTab) {
      if (oldTab.title !== newTab.title) {
        this.listTabs[oldTab.$attrs["data-name"]] = true;
        this.activeCurrentTab = newTab.$attrs["data-name"];
        this.$refs[oldTab.$attrs["data-name"]].sendData(
          this.assignedTabChange,
          oldTab.title,
          oldTab,
          newTab
        );
      }
    },
    assignedTabChange(
      isForward,
      linkToTabHasName,
      oldTab,
      newTab,
      flagIsClose
    ) {
      if (newTab && oldTab) {
        if (isForward) {
          this.listTabs[newTab.$attrs["data-name"]] = true;
          this.listTabs[oldTab.$attrs["data-name"]] = false;
          this.modalInfo.loading = false;
        } else {
          this.activateTab = linkToTabHasName;
          this.listTabs[newTab.$attrs["data-name"]] = false;
          this.listTabs[oldTab.$attrs["data-name"]] = true;
          this.modalInfo.loading = false;
        }
      } else {
        if (flagIsClose) {
          this.$modal.hide("clientsModal");
        }
      }
    },
    getInfo() {
      GeneralService.get(`/clients/${this.modalInfo.id}/title`)
        .then((data) => {
          this.dataForHeader = data.data.data;
        })
        .catch((e) => {});
      GeneralService.get(`/clients/${this.modalInfo.id}`)
        .then((data) => {
          this.dataForModal = data.data.data.rows[0];
        })
        .catch((e) => {});
    },
    beforeOpen(data) {
      this.modalInfo.modalOpened = true;
      this.modalInfo.id = data.params?.id;
      this.listTabs.mainTab = true;
      this.getInfo();
    },
    beforeClose() {
      this.updatedValues = {};
      this.dataForModal = {};

      this.mainInfo = {};
      (this.modalInfo = {
        modalOpened: false,
        id: null,
        loading: true,
      }),
        (this.activeCurrentTab = "mainTab");
      this.activateTab = null;
      Object.keys(this.listTabs).forEach((el, index) => {
        this.listTabs[el] = false;
      });
    },
    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },
  },
  mounted() {
    EventBus.$on("finishLoad", () => {
      this.modalInfo.loading = false;
    });
    EventBus.$on("closeModal", () => {
      this.$modal.hide("clientsModal");
    });
    EventBus.$on("updateMainModalComponent", () => {
      this.getInfo();
    });
  },
  created() {},
  computed: {
    BLAlert() {
      return (this.dataForModal?.blacklist_notification ?? "").length
        ? this.dataForModal?.blacklist_notification
        : false;
    },
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
  },
};
</script>
